export const RESPONSIBLE_PERSON_NAME_KEY = 'responsible_person_name'
export const RESPONSIBLE_PERSON_EMAIL_KEY = 'responsible_person_email'
export const RESPONSIBLE_PERSON_PHONE_KEY = 'responsible_person_phone'

/**
 * The responsible person of a base, a subcontractor or an operator: the name, the email
 * and the phone, each one typed.
 *
 * The record keeps the contact as three plain columns rather than as a link to a person,
 * and that is deliberate: it is the snapshot of who to call that was true when the base
 * was set up, and it has to survive the person's record changing or going away. Whoever
 * that is need not be in the people register at all - an operator's dispatcher usually
 * is not - so the name is a free text field, and the two contact fields beside it are
 * typed with it instead of being filled in from a picked person.
 */
export function useResponsiblePerson () {
  const textField = (key, label) => ({
    key,
    label,
    creatable: true,
    editable: true,
    visible: true
  })

  const responsiblePersonField = (label) => textField(RESPONSIBLE_PERSON_NAME_KEY, label)

  // The one of the three that is checked as it is typed: the endpoints validate it as an
  // email address, so saying so here saves the round trip. TextField maps the shorthand
  // to its own validator, and an empty field passes - `required` is a rule of its own.
  const responsiblePersonEmailField = (label) => ({
    ...textField(RESPONSIBLE_PERSON_EMAIL_KEY, label),
    props: {
      rules: ['email']
    }
  })

  const responsiblePersonPhoneField = (label) => textField(RESPONSIBLE_PERSON_PHONE_KEY, label)

  return {
    responsiblePersonField,
    responsiblePersonEmailField,
    responsiblePersonPhoneField
  }
}
